<!-- //
定制化：文件日志侧边树组件(三层 第一层：服务名，第二层：SLB或者服务IP，第三次：日志名)，数据自动注册
没有手动添加，修改，所以无法编辑，新增修改。
@auth xuyd
@date 2024-05-01
//-->
<template>
  <div style="height: 100%; position: relative;">
    <div v-show="showBar" style="height: 100%;" :style="{width: width + 'px'}">
      <div class="flex-row" style="padding-bottom: 5px">
        <el-input size="small" v-model="searchVal" placeholder="关键字搜索" class="input-append" clearable>
        </el-input>
      </div>
      <div class="tree-wrapper">
        <el-tree ref="refPageableTree"
                 :props="props"
                 :show-checkbox="false"
                 :node-key="nodeKey"
                 lazy
                 :load="loadNode"
                 :expand-on-click-node="true"
                 :filter-node-method="filterNode"
                 :highlight-current="true"
                 @node-click="handleNodeClick"
        >
          <div class="custom-tree-node" slot-scope="{data, node}">
            <div class="content">
              <span :class="getNodeIcon(node, data)">
                {{ node.label }}
              </span>
              <span v-if="data[props.tipKey]">
                ({{ `${data[props.tipKey]}` }})
              </span>
              <div class="opts" v-if="data.tag !== 'loadMore'">
                <div class="menu-wrapper">
                  <el-button v-if="node.isLeaf"
                             type="text"
                             size="small"
                             icon="el-icon-more"
                             @click.stop="handleGroupMenu(data, $event)"/>
                  <el-button v-else
                             size="small"
                             type="text"
                             icon="el-icon-refresh"
                             @click.stop="handleGroupRefresh(data, node, $event)"/>
                </div>
              </div>
            </div>
          </div>
        </el-tree>
      </div>
      <ContextMenu ref="refContextMenu" @command="handleMenuCmd"/>
    </div>
    <CollapseBar v-model="showBar" position="left" style="position: absolute; right: 0; top: 50%;" class="collapse"/>
  </div>
</template>

<script>
import ContextMenu from './ctx-menu'

const DEFAULT_PROPS = {
  children: 'children',
  label: 'label',
  hasCount: false,
  tipKey: 'count',
  leafIcon: "document", // 叶子节点icon显示文件夹（folder）/文件（document）/空（""）
  folderClick: false, // 目录是否能
  maxLevel: -1, // 默认不限层级(root的手动添加虚拟不包含，节点的level从0开始
};
export default {
  name: 'CompSideTree',
  components: {ContextMenu},
  data() {
    return {
      showBar: true,
      searchVal: null,
      currentNode: null,
      props: this.$util.mergeObject(DEFAULT_PROPS, this.defaultProps)
    }
  },
  props: {
    width: {
      type: Number,
      default: 200,
    },
    nodeKey: {
      type: String,
      default: 'code',
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    defaultCurrentNode: {
      type: String,
      default: 'root', // [root：根节点|first：第一条业务数据]
    },
    load: Function,
    pageableLoad: Function,
    defaultProps: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  watch: {
    searchVal(val) {
      this.$refs.refPageableTree.filter(val);
    },
  },
  methods: {
    // 树节点懒加载
    async loadNode(node, resolve) {
      console.log("树节点懒加载", node)
      let treeList = [];
      if (node.level === 0) {// 获取第一层数据
        await this.load({code: ''}).then(list => {
          treeList = list.map(item => ({
            ...item, leaf: false
          }));
        });
      } else if (node.level === 1) {// 获取第二层数据
        await this.load({code: node.data.code}).then(list => {
          treeList = list.map(item => ({
            ...item, leaf: false
          }));
        });
      } else if (node.level === 2) {// 获取第三层数据，加载更多触发父节点事件
        await this.pageableLoad(node.data).then(retData => {
          treeList = retData.records.map(item => ({
            ...item, leaf: true
          }));

          // 数据添加到父节点下
          node.data.children = node.data.children || [];
          // 移除最后一条是【loadMore】的记录
          if(node.data.children.length > 0) {
            if(node.data.children[node.data.children.length - 1].tag === 'loadMore') {
              node.data.children.splice((node.data.children.length - 1), 1)
            }
          }
          // node的children放一份
          // 拼接node的children，即父级节点的所有children
          node.data.children.push(...treeList);
          treeList = [...node.data.children];

          // 构造数据，并resolve
          if(retData.current < retData.pages) {
            treeList.push({
              text: '加载更多...',
              tag: 'loadMore',
              leaf: true,
              pcode: node.data.code,
              code: `${node.data.code}_more`,
              pageNum: retData.current + 1,
              pageSize: retData.size,
            })
          }
          // console.log("----treeList----->", treeList)
        });
      }
      resolve(treeList || []);
    },

    filterNode(val, data) {
      if (!val) return true;
      return data[this.props.label].indexOf(val) !== -1;
    },

    // 点击节点
    handleNodeClick(nodeData, node) {
      this.currentNode = nodeData;
      if (nodeData.tag === 'loadMore') {
        console.log("---- 加载更多------", nodeData, node);
        // 重新加载父节点（IP节点）以获取下一页数据
        node.parent.loaded = false;
        node.parent.data.pageNum = nodeData.pageNum;
        node.parent.data.pageSize = nodeData.pageSize;
        node.parent.loadData();
      } else if (nodeData.tag === 'file') {
        console.log("-----查看日志内容------", nodeData, node);
        this.$emit('change', nodeData);
      }
      this.$refs.refContextMenu.closeMenu();
    },

    // 根据节点类型获取图标类名
    getNodeIcon(node, data) {
      const baseClass = 'node-icon'
      if (node.level == '1') {
        return `${baseClass} first-level-icon`
      } else if (node.level == '2') {
        return `${baseClass} second-level-icon`
      } else if (node.level == '3' && data.tag === 'loadMore') {
        return `${baseClass} loadMore-icon`
      } else if (node.level == '3') {
        return `${baseClass} third-level-icon`
      } else {
        return baseClass
      }
    },

    /**
     * 刷新
     * @param nodeData 节点数据
     * @param node 节点对象
     * @param e 事件
     */
    handleGroupRefresh(nodeData, node, e) {
      console.log("----handleGroupRefresh------>", nodeData, node);
      // 重置数据
      nodeData.pageNum = 1;
      if(nodeData.children) {
        nodeData.children = [];
      }
      node.loaded = false;
      node.expand();
    },

    /**
     * 显示菜单
     * @param item
     * @param e
     */
    handleGroupMenu(item, e) {
      console.log("----handleGroupMenu------>", item);
      const menuMinWidth = 100;
      const offsetLeft = this.$el.getBoundingClientRect().left;
      const offsetWidth = this.$el.offsetWidth;
      const maxLeft = offsetWidth - menuMinWidth + offsetLeft;
      const eventX = e.clientX;
      let left;
      if (eventX > maxLeft) {
        left = maxLeft;
      } else {
        left = eventX;
      }
      let top = e.clientY;
      this.$refs.refContextMenu.openMenu({left: left, top: top, rowData: item})
    },
    /**
     * 菜单处理
     * @param command
     * @param nodeData
     */
    handleMenuCmd(command, nodeData) {
      console.log("----handleMenuCmd------>", command, JSON.stringify(nodeData.id));
      switch (command) {
        case 'download':
          this.$refs.refContextMenu.closeMenu();
          this.$modal.confirm(`请确认是否下载该记录？`).then(() => {
            new Promise(resolve => this.$emit('download', nodeData.id, resolve)).then(retData => {
              this.$modal.msgSuccess('下载成功');
            });
          });
          break;
        case 'delete':
          this.$refs.refContextMenu.closeMenu();
          this.$modal.confirm(`请确认是否删除该记录？`).then(() => {
            new Promise(resolve => this.$emit('delete', nodeData.id, resolve)).then(retData => {
              this.$modal.msgSuccess('删除成功');
              this.reload();
            });
          });
          break;
      }
    }
  }
}
</script>
<style lang="less" scoped>
.scroll-container {
  height: calc(100% - 37px);
  box-sizing: border-box;

  .el-scroller__wrap {
    overflow-x: auto;
    overflow-y: auto;
  }
}

.tree-wrapper {
  flex: 1;
  height: calc(100% - 37px);
  padding-bottom: 20px;
  box-sizing: border-box;
  overflow-x: auto;
  overflow-y: auto;
}

:deep(.el-tree-node__content):hover .opts {
  display: inline-block;
}

.custom-tree-node {
  width: 100%;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .opts {
    display: none;
    position: absolute;
    right: 0;
    width: 20px;
    height: 20px;
    background-color: rgba(238, 222, 222, 0.35);
  }

  .menu-wrapper {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .content {
    display: flex;
    align-items: center;
  }
}

.first-level-icon::before {
  content: "📁";
}

.second-level-icon::before {
  content: "🖥️";
}

.third-level-icon::before {
  content: "📄";
}

.loadMore-icon::before {
  content: "⬇️";
}
</style>
